import React from 'react';
import '../../css/clipboard.less';

export const copyToClipboard = ({ currentTarget }) => {

    const selection = window.getSelection();

    selection.removeAllRanges();
    currentTarget.previousSibling.select();

    if (document.queryCommandSupported('copy')) { 
        document.execCommand('copy'); 
    } else { 
        console.error('Copying is not supported on your device'); 
    }
};

export const selectText = ({ target }) => target.select();

const ClipboardInput = ({ value, buttonTitle }) => (
    <div className="key-input-width grouped-control">
        <input 
            className="key-input-width grouped-control-input clipboard-input" 
            readOnly 
            onClick={selectText} 
            value={value}
            size="60"
        />
        <button 
            className="grouped-control-button clipboard-copy" 
            title={buttonTitle}
            onClick={copyToClipboard}
        >
            <span className="glyphicon glyphicon-copy" />
        </button>
    </div>
);


export default ClipboardInput;
